import moment from 'moment';

const populateMergeTags = (messageBody, client, trainer) => {
  const mergeTags = {
    firstName: client.firstName,
    lastName: client.lastName,
    trainerFirst: trainer.firstName,
    trainerLast: trainer.lastName,
    todayDay: moment().format('dddd'),
  };

  let newMessageBody = messageBody;

  Object.keys(mergeTags).forEach((key) => {
    newMessageBody = newMessageBody.replace(`{${key}}`, mergeTags[key]);
  });

  return newMessageBody;
};

const mergeTagKeys = [
  '{firstName}',
  '{lastName}',
  '{trainerFirst}',
  '{trainerLast}',
  '{todayDay}',
];

export { populateMergeTags, mergeTagKeys };
